import { atom, selector } from "recoil";

//현재 평가 문항의 배열 번호
export const evaluateArrayIndexSelector = selector({
  key: "evaluateArrayIndexSelector",
  get: ({ get }) => {
    const evaluateCombo = get(evaluateComboState);
    const evaluateIndex = get(evaluateIndexState);
    const index = (evaluateCombo.current - 1) * 3 + (evaluateIndex.current - 1);

    return index;
  },
});

//평가 문항 번호
export const evaluateIndexState = atom({
  key: "evaluateIndexState",
  default: {
    current: 1,
    total: 3,
  },
});

//현재 평가 콤보 번호
export const evaluateComboState = atom({
  key: "evaluateComboState",
  default: {
    current: 1,
    total: 30,
  },
});

//평가 항목 설정
export const evaluationQuestionsListState = atom({
  key: "evaluationQuestionsListState",
  default: [],
});

//나의 현재 평가 정보
export const evaluationListState = atom({
  key: "evalutationListState",
  default: [{}, {}, {}],
});

//코멘트 설정
export const raterCommentListState = atom({
  key: "raterCommentListState",
  default: [],
});

//평가 방 번호(sn)

export const evaluationRoomSnState = atom({
  key: "evaluationRoomSnState",
  default: 0,
});

export const raterRoomListState = atom({
  key: "raterRoomListState",
  default: [],
});

export const evaluationItemsState = atom({
  key: "evaluationItemsState",
  default: [],
});

//콤보의 모든 항목이 평가 되었는지
export const canEvaluateSelector = selector({
  key: "canEvaluateSelector",
  get: ({ get }) => {
    //모든 항목 체크시 true 리턴
    const evaluationList = get(evaluationListState);

    for (let item of evaluationList) {
      if (item?.ratingList) {
        for (let rating of item.ratingList) {
          if (rating.score === undefined) {
            return false;
          }
        }
      } else {
        return false;
      }
    }

    return true;
  },
});

//현재 문항 번호가 평가 되었는지
export const isCurrentIndexEvaluatedSelector = selector({
  key: "isCurrentIndexEvaluatedSelector",
  get: ({ get }) => {
    const evaluationList = get(evaluationListState);
    const evaluateIndex = get(evaluateIndexState);
    const currentEv = evaluationList[evaluateIndex.current - 1];

    if (!currentEv) {
      return false;
    }

    if (currentEv.ratingList) {
      for (let rating of currentEv.ratingList) {
        if (rating.score === undefined) {
          return false;
        }
      }
    } else {
      return false;
    }

    return true;
  },
});

// 평가자 수정하기에서 사용할 recoil state
export const raterQuestionStartState = atom({
  key: "raterQuestionStartState",
  default: false,
});
